import { getToken } from "../services/authUtil";
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const getReservations = async (resortId, viewType, date, page = 1) => {
  try {
    const token = getToken();
    const url = new URL(`${API_BASE_URL}/reservation/${resortId}`);
    url.searchParams.append("type", viewType);
    url.searchParams.append("date", date);
    url.searchParams.append("page", page);

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    if (response.ok) {
      return data;
    }
    throw new Error(data.message || "Failed to fetch reservations");
  } catch (error) {
    throw new Error(error.message || "Failed to fetch reservations");
  }
};

const request = async (method, path, body, params = {}, idempotencyKey) => {
  const url = new URL(`${API_BASE_URL}${path}`);
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") url.searchParams.set(key, value);
  });

  const headers = {
    Authorization: getToken() ? `Bearer ${getToken()}` : "",
    "Content-Type": "application/json",
    Accept: "application/json",
  };
  if (idempotencyKey) headers["Idempotency-Key"] = idempotencyKey;

  const response = await fetch(url.toString(), {
    method,
    headers,
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = payload.message || (payload.errors && Object.values(payload.errors).flat()[0]) || "Reservation request failed";
    throw new Error(message);
  }
  return payload.data ?? payload;
};

export const getBookingAvailability = (propertyCode, filters) =>
  request("POST", `/properties/${encodeURIComponent(propertyCode)}/reservations/availability`, filters);

export const createPropertyReservation = (propertyCode, payload, idempotencyKey) =>
  request("POST", `/properties/${encodeURIComponent(propertyCode)}/reservations`, payload, {}, idempotencyKey);

export const getReservationHistory = (propertyCode, filters = {}) =>
  request("GET", `/properties/${encodeURIComponent(propertyCode)}/reservations`, null, filters);

export const getReservationDetails = (propertyCode, reservationId) =>
  request("GET", `/properties/${encodeURIComponent(propertyCode)}/reservations/${reservationId}`);

export const retryReservationOtaSync = (propertyCode, reservationId) =>
  request("POST", `/properties/${encodeURIComponent(propertyCode)}/reservations/${reservationId}/resync`);
